module.exports = ".custom-loader-s {\r\n    margin: 0 auto;\r\n    display: table;\r\n}\r\n.loader-response-s {\r\n    display: none;\r\n}"